import { apiServerRoutes } from "../constants/apiRoutes";
import {
  getAPICallServer,
  postAPICallServer,
  putAPICallServer,
} from "../utils/axios.util";

class BookingService {
  create(req: any) {
    return postAPICallServer(apiServerRoutes.CREATE_BOOKING, req.body, req);
  }
  fetch(req: any) {
    const { page_no, page_size, filter, request_type, search = "" } = req.body;
    const params = new URLSearchParams({
      page_no,
      page_size,
      filter,
      request_type,
      search,
    });
    return getAPICallServer(
      `${apiServerRoutes.LIST_BOOKING}?${params.toString()}`,
      req
    );
  }
  updateStatus(req: any) {
    const { id } = req.body;
    delete req.body.id;

    return putAPICallServer(
      `${apiServerRoutes.UPDATE_BOOKING_STATUS.replace(":id", id)}`,
      req.body,
      req
    );
  }
  completePayment(req: any) {
    const { id } = req.body;
    delete req.body.id;

    return postAPICallServer(
      `${apiServerRoutes.COMPLETE_BOOKING_PAYMENT.replace(":id", id)}`,
      req.body,
      req
    );
  }
  uploadDocuments(req: any) {
    const { id } = req.body;
    delete req.body.id;

    return postAPICallServer(
      `${apiServerRoutes.UPLOAD_BOOKING_DOCS.replace(":id", id)}`,
      req.body,
      req
    );
  }
  suggestDates(req: any) {
    const { id } = req.body;
    delete req.body.id;

    return postAPICallServer(
      `${apiServerRoutes.SUGGEST_DATE_CHANGES.replace(":id", id)}`,
      req.body,
      req
    );
  }
  saveSuggestDates(req: any) {
    const { id } = req.body;
    delete req.body.id;

    return postAPICallServer(
      `${apiServerRoutes.SAVE_DATE_CHANGES.replace(":id", id)}`,
      req.body,
      req
    );
  }
  fetchDetails(req: any) {
    const { id } = req.body;
    return getAPICallServer(
      `${apiServerRoutes.BOOKING_DETAILS.replace(":id", id)}`,
      req
    );
  }
}

export default new BookingService();
